import { useContext, useEffect, useState } from "react"
import { TbArrowBack } from "react-icons/tb"
import { useLocation, useNavigate } from "react-router-dom"
import Modal from "../../Components/Modal"
import Spinner from "../../Components/Spinner"
import UserContext from "../../Context/UserContext"
import { getEventDoc, updateEventDoc } from "../../Requests/firebaseFirestore"
import { uploadMailImage, uploadFormBanner } from "../../Requests/firebaseStorage"
import { setReminderAction } from "../../Requests/sendMail"

export default function EventMails() {
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [emailModal, setEmailModal] = useState(false)
  const [emailOptions, setEmailOptions] = useState('')
  const [editImageModal, setEditImageModal] = useState(false)
  const [oldImage, setOldImage] = useState()
  const [newImage, setNewImage] = useState({type:'', file:''})
  const [event, setEvent] = useState({})
  const {user} = useContext(UserContext)
  const [saving, setSaving] = useState(false)
  const [emailError, setEmailError] = useState('')
  const setImages = async () => {
    const res = await getEventDoc(location.state.id)
    setEvent(res)
    setOldImage({...res.emailImages, footer:res.footer})
  }

  useEffect(()=>{
    if(location.state===null){
      navigate(`/${user.role}`)
    }
    setImages()
    setLoading(false)
  },[location, navigate])

  const handleEmailModal = (emailType) => {
    setEmailError('')
    let actionId = ''
    if(event.reminders){
      switch (emailType) {
        case 'week':
          actionId = event.reminders.week
          break;
        case 'day':
          actionId = event.reminders.day
          break;
        case 'hour':
          actionId = event.reminders.hour
          break;
        default:
          break;
      }
    }else{
      setEvent({...event, reminders:{week:'', day:'', hour:''}})
    }
    setEmailOptions({type: emailType, actionId: actionId})
    setEmailModal(!emailModal)
  }

  const handleEditImageModal = (type) => {
    setNewImage({type:type, file:''})
    setEditImageModal(!editImageModal)
  }

  const handleInput = (e) =>{
    const {files} = e.target
    setNewImage({...newImage, file:files[0]})
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    let imageUrl
    switch(newImage.type){
      case 'footer':
        imageUrl = await uploadFormBanner(newImage.file, location.state.id, `footer-${location.state.id}`, newImage.file.type)
        await updateEventDoc(location.state.id, {footer:imageUrl})
        await setImages()
        break;
      default:
        imageUrl = await uploadMailImage(newImage.file, location.state.id, newImage.type, newImage.file.type)
        await updateEventDoc(location.state.id, {emailImages:{...oldImage, [newImage.type]:imageUrl}})
        await setImages()
        break;
    }
    /*
    handleEditImageModal()
    */
  }

  const handleSubmitActionId = async (e) => {
    e.preventDefault()
  
    const displayNumber = (n) => {
      let res
      if(n<10){
        res = `0${n}`
      }else{
        res = n
      }
      return res
    }

    setSaving(true)
    let eventDate = new Date(event.date)
    let hour = event.startTime.substring(0,2)
    let minute = event.startTime.substring(3, 5)
    eventDate.setHours(hour)
    eventDate.setMinutes(minute)
    eventDate.setDate(eventDate.getDate()+1)
    let timeZone = parseInt(event.timeZone) + 3
    eventDate.setHours(eventDate.getHours()+timeZone)
    switch (emailOptions.type) {
      case 'week':
        eventDate.setDate(eventDate.getDate()-7)
        break;
      case 'day':
        eventDate.setDate(eventDate.getDate()-1)
        break;
      case 'hour':
        eventDate.setHours(eventDate.getHours()-4)
        break;
        default:
          break;
        }
    let timeString = `${eventDate.getFullYear()}`+`${displayNumber(eventDate.getMonth()+1)}`+`${displayNumber(eventDate.getDate())}`+`${displayNumber(eventDate.getHours())}`+`${displayNumber(eventDate.getMinutes())}`+'00'
    const {status, message} = await setReminderAction(emailOptions.actionId, location.state.id, timeString)
    if(status === 200){
      switch (emailOptions.type) {
        case 'week':
          await updateEventDoc(location.state.id, {reminders:{...event.reminders, week:emailOptions.actionId} })
          setEvent({...event, reminders:{...event.reminders, week:emailOptions.actionId}})
          break;
        case 'day':
          await updateEventDoc(location.state.id, {reminders:{...event.reminders, day:emailOptions.actionId} })
          setEvent({...event, reminders:{...event.reminders, day:emailOptions.actionId}})
          break;
        case 'hour':
          await updateEventDoc(location.state.id, {reminders:{...event.reminders, hour:emailOptions.actionId} })
          setEvent({...event, reminders:{...event.reminders, hour:emailOptions.actionId}})
          break;
          default:
            break;
          }
      handleEmailModal()
    }else{
      switch(message){
        case 'action-error':
          setEmailError('El ID ingresado no es válido.')
          break;
        case 'date-error':
          setEmailError('No se pudo setear la fecha de envío.')
          break;
        case 'confirm-error':
          setEmailError('No se pudo confirmar el envío')
          break;
        default:
          setEmailError('Ha ocurrido un error.')
          break;
      }
    }
    console.log(status)
    
    setSaving(false)
  }

  return <div className="container mx-auto px-4">
    {loading?
    <div>
      <Spinner/>
    </div>:
    <>
    <div className="flex my-4 gap-4 items-center">
    <button className="action-btn" onClick={()=>{navigate('/organizer/events')}}><TbArrowBack size={25}/>Volver</button>
    <h1 className="text-stone-600 font-semibold text-xl py-2">Emails de {location.state.title}</h1>
    </div>
    <h1  className="text-stone-600 font-semibold text-xl py-2">Imagenes:</h1>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <button className="group-btn" onClick={()=>{handleEditImageModal('banner')}}>Header</button>
      <button className="group-btn" onClick={()=>{handleEditImageModal('location')}}>Imagen de locación</button>
      <button className="group-btn" onClick={()=>{handleEditImageModal('footer')}}>Footer</button>
    </div>
    <h1  className="text-stone-600 font-semibold text-xl py-2">Emails:</h1>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <button className="group-btn" onClick={()=>{handleEmailModal('week')}}>Recordatorio (Semana antes)</button>
      <button className="group-btn" onClick={()=>{handleEmailModal('day')}}>Recordatorio (Día antes)</button>
      <button className="group-btn" onClick={()=>{handleEmailModal('hour')}}>Recordatorio (4 horas antes)</button>

    </div>
    <Modal isActive={editImageModal} handle={handleEditImageModal} title='Cambiar imagen'>
      <form className="flex flex-col justify-center gap-4" onSubmit={handleSubmit}>
      {newImage.type!==''?
      <>
      {oldImage[newImage.type]?
      <>
      <h1 className="w-[75%] mx-auto">Imagen actual:</h1>
      <img src={oldImage[newImage.type]} alt={newImage.type} className='w-[75%] max-h-[200px] object-contain mx-auto'/>
      </>
      :<></>}</>:<></>}
        <div className="mx-auto w-[75%]">
        <input type="file" accept=".png, .jpeg, .jpg" name={newImage.type} onChange={(e)=>{handleInput(e)}} required/>
        </div>
        <button className="send-btn">Guardar</button>
        {newImage.type==='footer'?
        <span className="block text-center">Esto afectará también al footer del formulario</span>:<></>}
      </form>
    </Modal>
    <Modal isActive={emailModal} handle={handleEmailModal} title='Establecer mail de recordatorio'>
        <div className="w-[75%] flex flex-col gap-4 mx-auto">
          <h1>Indique el ID del mensaje de emBlue, el mail se enviará a todos los asistentes ya registrados.</h1>
          {
            emailOptions.actionId === ''?<span>No se específico ningúna campaña.</span>:<></>
          }
          <form onSubmit={handleSubmitActionId} className='flex flex-col gap-4'>
            <div className="input-holder w-full">
              <input type="text" id="email-action-id" required value={emailOptions.actionId || ''} onChange={(e)=>{setEmailOptions({...emailOptions, actionId:e.target.value})}}/>
              <label htmlFor="email-action-id">Action id</label>
            </div>
            {
              emailError !== ''?<span className="mx-auto text-center">{emailError}</span>:<></>
            }
            <button className="send-btn mx-auto block" disabled={saving}>{saving?'Guardando...':'Guardar'}</button>
          </form>
        </div>
    </Modal>
    </>}
  </div>
}